export { default } from './ProductInfoPopUp'
